import { storage } from '@common/utils/util'
//全局getters
export const userAttrId = state => {
    return state.userAttrId || storage.session.get('userAttrId');
}

export const userInfo = state => {
    let userInfo = state.userInfo;
    if (userInfo && userInfo.hasOwnProperty('openId')) {
        return userInfo;
    }

    return storage.local.get('userInfo');
}

export const customerLink = state => {
	return state.customerLink || "";
}


// WEBPACK FOOTER //
// ./src/store/getters.js